import UsersTable from './UsersTableContainer';

export default UsersTable;
